// extracted by mini-css-extract-plugin
export default {"intro":"home-module--intro--bet1c","block":"home-module--block--xtdjN","icon-Global-globe":"home-module--icon-Global-globe--OQNpK","button":"home-module--button--_Boy0"};